module.exports = "<div ng-class=\"{\n  container: !$$setting.data.general.checkboxs.largeMode.model,\n  largeContainer: $$setting.data.general.checkboxs.largeMode.model\n}\">\n  <div ui-view>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/scrapping/templates/index.html
// module id = 1631
// module chunks = 0